<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <ScreeCompany @ScreeCompany="ScreeCompany"/>
        </el-row>
        <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
          <el-table-column
            slot="first-column"
            align="center"
            label="公司名称">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
                <div>{{ scope.row.company_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="结算单">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.file_url)">
                  <i class="iconfont iconwenjian iconbtn iconBtns" @click="downButton(scope.row)"></i>
                </el-button>
                <el-button size="mini" style="margin-left:-10px" type="text" @click="mxGoUrl(scope.row.file_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              prop="money"
              align="center"
              sortable
              label="总金额">
              <template slot-scope="scope">
                <div class="tag-group">
                  <el-tag type="warning" class="tag-item">
                    <div>总金额：{{scope.row.total_amount}}</div>
                  </el-tag>
                  <el-tag type="warning" class="tag-item">
                    <div>人员数：{{scope.row.total_num}}</div>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="180"
              label="操作"
              align="center">
              <template slot-scope="scope">
              <span>
                <el-button size="mini" type="danger" v-if="scope.row.status === 1" @click="viewButton(scope.row.id, 'audit')">审批任务</el-button>
                <el-button size="mini" type="primary" @click="viewButton(scope.row.id, 'detail')">发放明细</el-button>
                  <!-- <el-button size="mini" type="default" v-if="userPermissions.indexOf('company_edit') != -1"  @click="editButton(scope.row.id)">电子回单</el-button> -->
              </span>
              </template>
            </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>
    <!-- 审批组建 -->
    <BatchDetail
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogBatchVisible="approvaDialogVisible"
      :batchId="batchId"
      :dialogType="'audit'"/>
    <!-- 发放明细 -->
    <BatchDetail
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleDetailSuccess($event)"
      :dialogBatchVisible="detailDialogVisible"
      :batchId="batchId"
      :dialogType="'detail'"/>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import BatchDetail from './BatchDetail.vue'
import ScreeCompany from '@/components/ScreeCompany.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    BatchDetail,
    ScreeCompany
  },
  data() {
    return {
      batchId: '',
      detailDialogVisible: false,
      approvaDialogVisible: false,
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      tableData: [],
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      columns: [
        {
          title: '任务名称',
          value: 'name',
          header_align: 'center',
          align: 'center',
        },
         {
          title: '税源地名称',
          value: 'channel_name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '成功金额',
          header_align: 'center',
          align: 'center',
          value: 'alias_succeed_money',
        },
        {
          title: '失败金额',
          header_align: 'center',
          align: 'center',
          value: 'alias_failed_money',
        },
        {
          title: '发放状态',
          header_align: 'center',
          align: 'center',
          value: 'send_msg',
        },
        {
          title: '批次状态',
          header_align: 'center',
          align: 'center',
          value: 'alias_status',
        },
        {
          title: '创建时间',
          header_align: 'center',
          align: 'center',
          value: 'created_at',
          // width: 170
        },
           {
          title: '提交时间',
          header_align: 'center',
          align: 'center',
          value: 'updated_at',
          // width: 170
        },
      ],
      // 表格列表数据
      dataList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证

      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
    }
  }, 
  computed: {
    ...mapGetters(['userPermissions'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    ScreeCompany(v, name) {
      if (name == 'company') {
        if(v) {
          this.searchCondition.company_id = v
        } else {
          delete this.searchCondition.company_id
        }
        this.init('search')
      }

      if(name == 'settlement') {
        if (v) {
          this.searchCondition.channel_account = v
        } else {
          delete this.searchCondition.channel_account
        }
        this.init('search')
      }
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    // //导入调转
    // importExcel() {
    //   this.$router.push({path: 'task/import'})
    // },
    // 切换页码操作
    async switchPaging() {
      this.init()
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id, type='') {
      this.batchId = id
      if(type == 'detail'){
        //明细弹窗
        console.log("1111")
        this.detailDialogVisible = true
      }else {
        //审批弹窗
        console.log("2222")
        this.approvaDialogVisible = true
      }
    },
    // 审核成功回调
    handleSuccess() {
      this.approvaDialogVisible = false
      this.init()
      console.log("handleSuccess1")
    },
    // 明细详情回调
    handleDetailSuccess() {
      console.log("handleSuccess2")
    },
    // 统一关闭弹窗
    dialogChanged(type) {
      if (type == 'audit') {
        this.approvaDialogVisible = false
      }

      if (type == 'detail') {
        this.detailDialogVisible = false
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id)
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id)
      // let info = await this.$api.deleteSettlement(id)
      // if (info == 'ok') {
      //   this.$nextTick(() => {
      //     this.init('del')
      //   })
      // } else {
      //   this.$message.error(info)
      // }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0]
      this.searchCondition.end_time = value[1]
    },
    // 初始化列表
    async init(type) {
      if(type) {
        this.mxResetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let { data, pages} = await this.$api.getAdminTaskList(searchCondition)
      this.$nextTick(() => {
        this.dataList = data
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time
      }
      if (this.searchCondition.company_id || this.searchCondition.channel_account) {
        condition.company_id = this.searchCondition.company_id
        condition.channel_account = this.searchCondition.channel_account
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let id = await this.$api.saveCompanyAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init()
        })
      } else {
        this.$message.error(info)
      }

    },
    keyupSubmit(){
      document.onkeydown = e => {
        console.log(e)
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },

  created() {
    this.keyupSubmit()
  },
  mounted() {
    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .submitBtn
    float: right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .iconBtns
    font-size: 20px
    color: rgba(0, 183, 158, 1)
  .tag-group
    display: flex
    flex-direction: column
  .tag-item
    margin: 5px 0
  // .table-search
  //   height: 36px
</style>
